import React from 'react';

import { notEmpty } from 'utils/ramdaAdditions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import TablePerson from 'components/cards/person/table/TablePerson';

export const PersonWorkplaces = ({ workplaces }) => (notEmpty(workplaces) ? (
    <div>
        <DefinitionHeader translate="person.work.title" iconType="building" />
        <TablePerson items={workplaces} table="workPlaces" />
    </div>
) : null);
